<template>
  <section id="live-content">
    <section class="live-left">
      <index-data></index-data>
      <section class="live-list">
        <div class="live-nav">
          <div
            class="time"
            style="position:relative"
          >
            <time>{{ realTime }}</time>
            <span
              @click="showDateDiv"
              class="font-date"
              :class="showDiv ? 'blue' : ''"
              v-if="!liveSelectTime"
            >
              <i class="iconfont">&#xe622;</i>日期
            </span>
            <span
              class="detail-Time"
              @click="showDateDiv()"
              v-else
            >
              <i class="iconfont">&#xe622;</i>
              <span class="start-time">{{initTime(selectedTime[0]).format('Y年M月D日')}}</span>
              <span>-</span>
              <span class="end-Time">{{initTime(selectedTime[1]).format('Y年M月D日')}}</span>
              <i
                class="iconfont close-time"
                @click.stop="clearDate()"
              >&#xe6cb;</i>
            </span>
            <div
              v-if="showDiv"
              class="box-date-picker"
              style
            >
              <el-date-picker
                v-model="selectedTime"
                type="daterange"
                class="liveDatePicker"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['12:00:00']"
                @change="changeDate"
                @blur="dataPickerblur"
                ref="elDatePicker"
              ></el-date-picker>
            </div>
          </div>

          <div class="search">
            <div :class="['input-box',{focusInputBox: onfocus}]">
              <input
                type="text"
                placeholder="搜索"
                class="search-input"
                v-model.trim="searchQuery.keyword"
                @keyup.enter="searchLive(0)"
                @focus="onfocus = true"
                @blur="onfocus = false"
              >
              <i
                class="iconfont"
                @click="searchLive(0)"
              >&#xe633;</i>
            </div>
            <i
              v-if="isCloseInputSearch"
              @click="closeInputSearch"
              class="closeInputSearch"
            >取消搜索</i>
          </div>
        </div>
        <div class="list">
          <div
            class="filter"
            v-if="!isSearchLive"
          >
            <label
              for="readImportant"
              class="readImportant"
              :class="onlyImportant?'checked':''"
              @click="readImportant()"
            >
              只看重要的
              <span class="iconfont">{{onlyImportant ? '&#xe63c;':'&#xe63a;'}}</span>
            </label>
            <!-- </div> -->
          </div>
          <transition-group
            tag="ul"
            name="slideIn"
            v-if="dtbList.length > 0 && !isLoading"
          >
            <li
              v-for="(item,index) in dtbList"
              :key="item.id "
              class="live-li"
              :class="index === 0 || item.isnewDate ? 'noBorder':''"
              :id="item.isnewDate ? 'addPaddingTop':''"
            >
              <p
                v-if="item.isnewDate"
                class="toDay"
              >
                <span class="iconfont">&#xe605;</span>
                {{ initTime(item.createTime * 1000).format('Y-M-D')}}
              </p>
              <div
                class="time-detail"
                :class="item.level ? 'level':''"
              >
                <time>{{ initTime(item.createTime * 1000).format('H:m')}}</time>
                <span class="detail">
                  <span
                    class="title"
                    v-html="item.title"
                  ></span>
                  <span>
                    <span v-html="item.content"></span>
                    <span
                      class="view-picture"
                      @click="viewPicture(item)"
                      v-if="item.pictureList"
                    >
                      <i class="iconfont">&#xe636;</i>
                      {{item.isShowImg ? '收起图片':'查看图片'}}
                    </span>
                  </span>

                  <div v-if="item.pictureList && item.isShowImg">
                    <!-- <img :src="i.replace('!wm','')" alt="" v-for="i in item.pictureList" :key="i"> -->
                    <img
                      :src="i"
                      alt
                      v-for="i in item.pictureList"
                      :key="i"
                    >
                  </div>
                  <a
                    v-if="item.link"
                    class="link"
                    :href="item.link"
                    target="_blank"
                  >
                    <i class="iconfont">&#xe615;</i>
                    {{item.linkName}}
                  </a>
                </span>
                <div class="share">
                  <i class="iconfont">&#xe621;</i>分享
                  <div class="shareBtn">
                    <span @click="openwxshare(item.liveLink)">
                      <i class="iconfont">&#xe625;</i>微信
                    </span>
                    <span @click="openweiboshare(item.weiboshare)">
                      <i class="iconfont">&#xe626;</i>微博
                    </span>
                  </div>
                </div>
              </div>
            </li>
          </transition-group>
          <div v-if="!isLoading">
            <ul
              v-if="dtbList.length == 0"
              class="no-dtb"
            >
              <li>暂无直播</li>
            </ul>
            <p
              id="waterfall"
              v-if="dtbList.length > 0 && !isSearchLive"
            >
              <span @click="getMoreDtbData()">{{ $t('tag-article.more') }}</span>
            </p>
            <p
              id="waterfall"
              v-if="dtbList.length > 0 &&   dtbList.length < searchQueryTotal &&isSearchLive"
            >
              <span @click="searchLive(1,1)">{{ $t('tag-article.more') }}</span>
            </p>
            <p
              id="waterfall"
              v-if="dtbList.length > 0 && dtbList.length >= searchQueryTotal  && isSearchLive "
            >
              <span>没有更多了</span>
            </p>
          </div>
        </div>
      </section>
    </section>
    <section class="live-right">
      <hk-sidebar></hk-sidebar>
    </section>

    <section
      class="modal"
      v-show="isShowWxQrcode"
    >
      <section class="modal-alert">
        <div class="modal-alert-header">
          <span>分享到微信</span>
          <i
            class="iconfont"
            @click="closewxshare()"
          >&#xe73e;</i>
        </div>
        <div class="modal-alert-qrcode">
          <QR
            :value="qrSource"
            class="qrCode"
            tag="img"
            size="190"
            id="qr-code"
          ></QR>
          <p>打开手机微信“扫一扫”</p>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import * as api from "~/api/index";
import initTime from "~/plugins/initTime";
import indexData from "~/components/index/index-data.vue";
import QR from "qrcode.vue";
import hkSidebar from "~/components/public/hk-sidebar";
export default {
  name: "dtb-index",
  components: {
    indexData,
    QR,
    hkSidebar
  },
  async asyncData({ params, route, error, app, $axios }) {
    try {
      let dtbData = await $axios(
        api.getDtbList({ liveChannelId: "all", limit: 15 })
      );
      let dtbList = [];
      let liveId = null;
      let isLoading = false
      // 格式化数据格式
      if (dtbData && dtbData.result && dtbData.result.length > 0) {

        let data = dtbData.result ? dtbData.result : [];
        if (data.length == 0) {
          isLoading = true
          return
        }
        liveId = data[data.length - 1].id;
        data.forEach((item, index) => {
          item.isnewDate = item.isnewDate || false;
          item.isShowImg = false;
          item.liveLink = `https://m.gelonghui.com/live/${item.id}`;
          item.weiboshare = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
            "https://m.gelonghui.com/dtb/"
          )}${item.createTime}/${item.id}&title=【格隆汇直播】${
            item.content
            }&searchPic=false`;
          if (index < data.length - 1) {
            if (
              initTime(item.createTime * 1000).format("M-D") !=
              initTime(data[+index + 1].createTime * 1000).format("M-D")
            ) {
              data[index + 1].isnewDate = true;
            }
          }
          dtbList.push(item);
        });
      }
      return {
        dtbList: dtbList || [],
        liveId,
        qrSource: "",
        isLoading: isLoading
      };
    } catch (err) {
      console.log(err);
      error({ statusCode: 404, message: "直播error" });
    }
  },
  data() {
    return {
      realTime: null,
      timeInterval: null,
      realTimeInterval: null,
      isShowWxQrcode: false,
      qrSource: "",
      onlyImportant: false,
      isClickMore: false,
      newsestDtbData: null,
      liveChannelId: "all",
      isChange: false,
      selectedTime: [],
      showDiv: false,
      liveSelectTime: false,
      liveSelectkeyword: false,
      isSearchLive: false,
      searchQuery: {
        keyword: null,
        startTimestamp: null,
        endTimestamp: null,
        page: 1,
        count: 15
      },
      searchQueryTotal: null,
      isCloseInputSearch: false,
      onfocus: false
    };
  },
  mounted() {
    clearInterval(this.newsestDtbData);
    clearInterval(this.timeInterval);
    clearInterval(this.realTimeInterval);
    this.realTime = this.initTime().format("M月D日  星期W  H:m");
    this.realTimeInterval = setInterval(() => {
      this.realTime = this.initTime().format("M月D日  星期W  H:m");
    }, 1000);
    this.timeInterval = setInterval(() => {
      this.getNewDtbData();
    }, 30000);
  },
  methods: {
    closeInputSearch() {
      this.dtbList = [];
      this.isCloseInputSearch = false;
      this.searchQuery.keyword = null;
      this.searchQuery.page = 1;
      if (this.selectedTime.length !== 0) {
        this.searchLive(0);
      } else {
        this.liveSelectTime = false;
        clearInterval(this.newsestDtbData);
        clearInterval(this.timeInterval);
        clearInterval(this.realTimeInterval);
        this.getNewDtbData();
        this.realTime = this.initTime().format("M月D日  星期W  H:m");
        this.realTimeInterval = setInterval(() => {
          this.realTime = this.initTime().format("M月D日  星期W  H:m");
        }, 1000);
        this.timeInterval = setInterval(() => {
          this.getNewDtbData();
        }, 30000);
      }
    },
    clearDate() {
      this.isLoading = true;
      this.selectedTime = [];
      this.liveSelectTime = false;
      this.searchQuery.page = 1;
      if (this.searchQuery.keyword) {
        this.searchLive(0);
      } else {
        clearInterval(this.newsestDtbData);
        clearInterval(this.timeInterval);
        clearInterval(this.realTimeInterval);
        this.getNewDtbData();
        this.realTime = this.initTime().format("M月D日  星期W  H:m");
        this.realTimeInterval = setInterval(() => {
          this.realTime = this.initTime().format("M月D日  星期W  H:m");
        }, 1000);
        this.timeInterval = setInterval(() => {
          this.getNewDtbData();
        }, 30000);
      }
    },
    dataPickerblur() {
      this.showDiv = false;
    },
    changeDate(i) {
      this.showDiv = false;
      this.liveSelectTime = true;
      this.searchLive(1);
    },
    showDateDiv() {
      this.showDiv = !this.showDiv;
      if (this.showDiv) {
        setTimeout(() => {
          this.$refs.elDatePicker.focus();
        }, 0);
      }
    },
    async searchLive(i, isMore) {
      this.searchQueryTotal = isMore ? this.searchQueryTotal : 0;
      if (i) {
        this.isLoading = isMore ? false : true;
        this.isSearchLive = true;
        this.searchQuery.page = isMore
          ? this.searchQuery.page + 1
          : this.searchQuery.page;
      } else {
        if (!this.searchQuery.keyword && this.selectedTime.length == 0) return;
        this.searchQuery.page = 1;
        this.isSearchLive = true;
        this.dtbList = [];
        this.isLoading = isMore ? false : true;
        this.isCloseInputSearch = true;
        // this.isSearchLive = true
      }

      this.searchQuery.startTimestamp = this.selectedTime[0]
        ? new Date(this.selectedTime[0]).getTime() / 1000
        : null;
      this.searchQuery.endTimestamp = this.selectedTime[1]
        ? new Date(this.selectedTime[1]).getTime() / 1000
        : null;
      //先清除初始的定时器
      clearInterval(this.newsestDtbData);
      clearInterval(this.timeInterval);
      clearInterval(this.realTimeInterval);
      //获取时间戳后面的数据
      let dtbData = await this.$axios(api.searchSolrLive(this.searchQuery));
      this.searchQueryTotal = dtbData.totalCount;
      let data = dtbData.result;
      if (dtbData.statusCode === 200 && data && data.length > 0) {
        //格式化数据
        data.forEach((item, index) => {
          item.isShowImg = false;
          item.liveLink = `https://m.gelonghui.com/live/${item.liveId}`;
          item.weiboshare = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
            "https://m.gelonghui.com/dtb/"
          )}${item.createTime}/${item.id}&title=【格隆汇直播】${
            item.content
            }&searchPic=false`;
          item.isnewDate = item.isnewDate || false;
          if (index < data.length - 1) {
            if (
              initTime(item.createTime * 1000).format("M-D") !=
              initTime(data[index + 1].createTime * 1000).format("M-D")
            ) {
              data[index + 1].isnewDate = true;
            }
          }
        });

        //判断旧数据的最后一条的时间和新数据的第一条的时间是否为同一天,不同天则设置isnewDate为true
        if (this.dtbList.length > 0) {
          let oldDataLastCreatedTime = this.dtbList[this.dtbList.length - 1]
            .createTimestamp;
          let newDataFirstCreatedTime = data[0].createTime;
          if (
            initTime(oldDataLastCreatedTime * 1000).format("M-D") !=
            initTime(newDataFirstCreatedTime * 1000).format("M-D")
          ) {
            data[0].isnewDate = true;
          }
        } else {
          data[0].isnewDate = true;
        }

        // 判断是否读重要的
        // if (this.onlyImportant) {
        //   data = data.filter(item => { return item.level })
        //   this.dtbList.push(...data);
        // } else {
        //   this.dtbList.push(...data);
        // }
        this.dtbList.push(...data);
        this.isLoading = false;
      } else {
        this.dtbList = [];
        this.isLoading = false;
      }
    },
    initTime(t) {
      return initTime(t);
    },
    viewPicture(i) {
      i.isShowImg = !i.isShowImg;
    },
    readImportant() {
      clearInterval(this.newsestDtbData);
      clearInterval(this.timeInterval);
      clearInterval(this.realTimeInterval);
      this.timeInterval = null;
      this.realTimeInterval = null;
      this.newsestDtbData = null;
      this.onlyImportant = !this.onlyImportant;
      // this.liveChannelId = this.onlyImportant ? "carefulSelection" : "all";
      this.isClickMore = false;
      this.isChange = true;
      this.getNewDtbData();
      this.timeInterval = setInterval(() => {
        this.getNewDtbData();
      }, 60000);


    },
    // 打开微信分享
    openwxshare(i) {
      this.isShowWxQrcode = true;
      this.qrSource = encodeURI(i);
      document.body.style.overflow = "hidden";
    },
    //关闭微信分享
    closewxshare() {
      this.isShowWxQrcode = false;
      this.qrSource = "";
      document.body.style.overflow = "";
    },
    //微博分享
    openweiboshare(i) {
      window.open(i);
    },
    //记载更多逻辑
    async getMoreDtbData() {
      this.isSearchLive = false;
      this.isClickMore = true;
      //先清除初始的定时器
      clearInterval(this.newsestDtbData);
      clearInterval(this.timeInterval);
      //获取时间戳后面的数据
      let dtbData = await this.$axios(
        api.getDtbList({
          onlyShowImportant: this.onlyImportant,
          liveId: this.liveId,
          limit: 15
        })
      );

      let data = dtbData.result;
      if (dtbData.statusCode === 200) {
        this.liveId = data[data.length - 1].id;
        //格式化数据
        data.forEach((item, index) => {
          item.isShowImg = false;
          item.liveLink = `https://m.gelonghui.com/live/${item.id}`;
          item.weiboshare = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
            "https://m.gelonghui.com/dtb/"
          )}${item.createTime}/${item.id}&title=【格隆汇直播】${
            item.content
            }&searchPic=false`;
          item.isnewDate = item.isnewDate || false;
          if (index < data.length - 1) {
            if (
              initTime(item.createTime * 1000).format("M-D") !=
              initTime(data[+index + 1].createTime * 1000).format("M-D")
            ) {
              data[index + 1].isnewDate = true;
            }
          }
        });

        //判断旧数据的最后一条的时间和新数据的第一条的时间是否为同一天,不同天则设置isnewDate为true
        let oldDataLastCreatedTime = this.dtbList[this.dtbList.length - 1]
          .createTime * 1000;
        let newDataFirstCreatedTime = data[0].createTime * 1000;
        if (
          initTime(oldDataLastCreatedTime).format("M-D") !=
          initTime(newDataFirstCreatedTime).format("M-D")
        ) {
          data[0].isnewDate = true;
        }

        // 判断是否读重要的
        if (this.onlyImportant) {
          data = data.filter(item => {
            return item.level;
          });
          this.dtbList.push(...data);
        } else {
          this.dtbList.push(...data);
        }

        this.newsestDtbData = setInterval(() => {
          this.getNewDtbData();
        }, 30000);
      }
    },
    async getNewDtbData() {
      // this.isLoading = true
      this.isSearchLive = false;
      let dtbData = await this.$axios(
        api.getDtbList({ liveChannelId: this.liveChannelId, limit: 15, onlyShowImportant: this.onlyImportant })
      );
      let dtbList = [];
      if (dtbData.statusCode === 200) {
        let data = dtbData.result;
        //判断是否切换了只看标红,切换了liveID需要重写
        this.liveId = this.isChange ? data[data.length - 1].id : this.liveId;
        data.forEach((item, index) => {
          item.isnewDate = item.isnewDate || false;
          item.isShowImg = false;
          item.liveLink = `https://m.gelonghui.com/live/${item.id}`;
          item.weiboshare = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
            "https://m.gelonghui.com/dtb/"
          )}${item.createTime}/${item.id}&title=【格隆汇直播】${
            item.content
            }&searchPic=false`;
          if (index < data.length - 1) {
            if (
              initTime(item.createTime * 1000).format("M-D") !=
              initTime(data[+index + 1].createTime * 1000).format("M-D")
            ) {
              data[index + 1].isnewDate = true;
            }
          }
          dtbList.push(item);
        });

        this.isChange = false;

        //判断是否加载更多,是,获取最新的数据插入数组前面,否,则完全更新数据
        if (this.isClickMore) {
          //旧数据最新的那一条的id
          let oldNewsestDataCreateTime = this.dtbList[0].createTime;
          //最新的数据则是大于旧数据最新的id
          let newsData = dtbList.filter(item => {
            return item.createTime > oldNewsestDataCreateTime;
          });
          // 判断是否读重要的
          if (this.onlyImportant) {
            newsData = newsData.filter(item => {
              return item.level;
            });
          }
          //把最新数据插入就数据最前面
          if (newsData && newsData.length > 0) {
            this.dtbList.unshift(...newsData);
          }
        } else {
          // 判断是否读重要的
          if (this.onlyImportant) {
            this.dtbList = dtbList.filter(item => {
              return item.level;
            });
          } else {
            this.dtbList = dtbList;
          }
        }
        this.isLoading = false;
      }
    },
    //港股涨跌幅 成交额 成交量
    async getHighData({ type, sort }) {
      let highData = await this.$axios(
        api.getMarketRange({
          type: type,
          sort: sort
        })
      );
      if (type == "netChange") {
        this.netChange = highData.result;
      } else if (type == "turnVolume") {
        this.turnVolume = highData.result;
      } else if (type == "volume") {
        this.volume = highData.result;
      }
    },
    async getLowData({ type, sort }) {
      let lowData = await this.$axios(
        api.getMarketRange({
          type: type,
          sort: sort
        })
      );
      if (type == "netChange") {
        this.netChange = lowData.result;
      } else if (type == "turnVolume") {
        this.turnVolume = lowData.result;
      } else if (type == "volume") {
        this.volume = lowData.result;
      }
    }
  },
  computed: {},
  beforeRouteLeave(to, from, next) {
    clearInterval(this.newsestDtbData);
    clearInterval(this.timeInterval);
    clearInterval(this.realTimeInterval);
    this.timeInterval = null;
    this.realTimeInterval = null;
    this.newsestDtbData = null;
    next();
  },
  head() {
    return {
      title: '外汇投资实时行情_交易_炒股_证券-格隆汇',
      meta: [
        {
          hid: "description",
          name: "description",
          content: '格隆汇直播栏目提供外汇投资实时行情,外汇投资交易,外汇投资炒股,证券等内容,实时更新,格隆汇未来将陆续开通台湾、日本、印度、欧洲等市场.'
        },
        {
          hid: "keywords",
          name: "keywords",
          content: '外汇投资实时行情,外汇投资交易,外汇投资炒股,证券'
        }
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.gelonghui.com/live/"
        },
        {
          rel: "alternate",
          media: "only screen and (max-width:640px)",
          href: "https://m.gelonghui.com/live/"
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
#live-content {
  margin: auto;
  width: 1200px;
  padding-bottom: 50px;
  margin-top: 20px;
  background: #f8f8f8;
  height: auto;
  overflow: hidden;
  .live-left {
    width: 852px;
    min-height: 500px;
    float: left;
    .live-list {
      margin-top: 20px;
      background: #fff;
      height: auto;
      padding: 0 22px 20px 22px;
      .live-nav {
        width: 100%;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f4f5f9;
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          time {
            font-size: 16px;
            color: #222222;
            font-weight: bold;
            width: 180px;
            display: inline-block;
          }
          .font-date {
            display: flex;
            height: 14px;
            line-height: 14px;
            font-size: 14px;
            justify-content: center;
            align-items: center;
            width: 60px;
            border-left: 1px solid #666;
            margin-left: 10px;
            color: #666;
            padding-left: 10px;
            cursor: pointer;
            .iconfont {
              font-size: 20px;
            }
          }
          .blue {
            color: #3278d2 !important;
          }
          .box-date-picker {
            position: absolute;
            width: 685px;
            height: 420px;
            background: #fff;
            top: 40px;
            left: 0;
            z-index: 99;
            box-shadow: 0px 4px 8px 0px #e4e4e4;
            border-radius: 5px;
          }
          .detail-Time {
            font-size: 12px;
            height: 28px;
            font-size: 12px;
            width: 278px;
            background: #eeeeee;
            border-radius: 14px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0 10px;
            .close-time {
              color: #666666;
              cursor: pointer;
            }
          }
        }

        .search {
          // width: 250px;
          height: 32px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          .input-box {
            box-sizing: border-box;
            border-radius: 16px;
            background: #eee;
            width: 180px;
            height: 28px;
            margin-right: 10px;
            border: 1px solid transparent;

            .search-input {
              width: 160px;
              height: 28px;
              box-sizing: border-box;
              line-height: 28px;
              border: 1px solid transparent;
              background-color: transparent;
              outline: none;
              text-indent: 15px;
            }
            .search-input ::-ms-clear {
              display: none;
            }
            .iconfont {
              position: absolute;
              box-sizing: border-box;
              top: 0;
              bottom: 0;
              z-index: 10;
              left: 160px;
              margin: auto;
              color: #666;
              display: inline-block;
              width: 16px;
              height: 16px;
              cursor: pointer;
            }
          }
          .focusInputBox {
            border: 1px solid #3278d2;
            background: #fff;
          }
          .closeInputSearch {
            font-size: 12px;
            color: #666;
            cursor: pointer;
          }
        }
      }
      .list {
        width: 100%;
        .filter {
          overflow: hidden;
          .readImportant {
            display: flex;
            width: 100px;
            height: 38px;
            font-size: 12px;
            padding-top: 10px;
            float: left;
            cursor: pointer;
            justify-content: flex-start;
            align-items: center;
            // span {
            //   display: inline-block;
            //   width: 10px;
            //   height: 10px;
            //   border: 1px solid #666;
            //   margin-left: 3px;
            //   cursor: pointer;
            // }
            .iconfont {
              margin-left: 3px;
              font-size: 15px;
            }
            .spanChecked {
              background: #3278d2;
              border-color: #3278d2;
            }
          }
          .checked {
            color: #3278d2;
          }
        }
        ul {
          display: block;
          li.live-li {
            width: 100%;
            height: auto;
            border-top: 1px solid #e8e8e8;
            font-size: 15px;
            color: #222222;
            position: relative;
            .toDay {
              width: 852px;
              height: 50px;
              line-height: 50px;
              font-size: 14px;
              font-weight: bold;
              background: #fafcff;
              left: -22px;
              padding-left: 32px;
              position: absolute;
              z-index: 2;
              overflow: hidden;
              .iconfont {
                margin-right: 8px;
                font-size: 12px;
              }
            }
            .time-detail {
              padding-top: 19px;
              padding-bottom: 43px;
              display: flex;
              justify-content: space-between;

              time {
                width: 56px;
                font-size: 14px;
                color: #666666;
                font-weight: bold;
                display: inline-block;
                border-right: 1px solid #e8e8e8;
                line-height: 25px;
              }
              .detail {
                width: 729px;
                line-height: 1.7;
                display: inline-block;
                font-size: 15px;
                .title {
                  // font-weight: bold;
                  color: #222222;
                }
                .view-picture {
                  width: 100px;
                  color: #3278d2;
                  height: 18px;
                  padding-top: 3px;
                  font-size: 12px;
                  display: inline-flex;
                  align-items: center;
                  vertical-align: -2px;
                  cursor: pointer;
                  .iconfont {
                    // font-size: 18px;
                    font-size: 18px;
                    display: inline-block;
                  }
                }
                img {
                  max-width: 100%;
                  display: block;
                  margin: auto;
                }
                .link {
                  font-size: 14px;
                  color: #3278d2;
                  display: block;
                  .iconfont {
                    font-size: 14px;
                    margin-right: 3px;
                  }
                }
              }
              .share {
                position: absolute;
                right: 0;
                bottom: 20px;
                height: 12px;
                font-size: 12px;
                background: #0000;
                display: flex;
                align-items: center;
                cursor: pointer;
                .iconfont {
                  margin-right: 3px;
                }
                &:hover {
                  .shareBtn {
                    display: block;
                  }
                }
                .shareBtn {
                  position: absolute;
                  width: 92px;
                  height: 72px;
                  font-size: 14px;
                  display: flex;
                  flex-flow: column wrap;
                  align-items: center;
                  top: 12px;
                  left: -40px;
                  z-index: 10;
                  background: #fff;
                  border-radius: 3px;
                  display: none;
                  padding: 8px 0;
                  // box-shadow: -1px 3px 5px #7c7c7c;
                  box-shadow: 0px 4px 8px 0px rgba(124, 124, 124, 0.21);
                  span {
                    width: 100%;
                    height: 28px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .iconfont {
                      margin-right: 5px;
                    }
                    &:hover {
                      color: #3278d2;
                    }
                  }
                }
              }
            }
          }
          .live-li.noBorder {
            border-top: none;
            // padding-top: 50px;
          }
          #addPaddingTop {
            .time-detail {
              padding-top: 69px;
            }
          }
        }
        .no-dtb {
          text-align: center;
          line-height: 80px;
          height: 80px;
          color: #666;
        }
      }
    }
  }
  .live-right {
    float: right;
    width: 328px;
    background-color: #f8f8f8;
  }
  .level {
    time {
      color: #eb3d2b !important;
    }
    .detail {
      color: #eb3d2b !important;
    }
    .title {
      color: #eb3d2b !important;
    }
  }

  .slideIn-enter-active,
  .slideIn-leave-active {
    transition: all 1s;
  }

  .slideIn-enter,
  .slideIn-leave {
    opacity: 0;
    transform: translateY(-20px);
  }
  .modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    outline: 0;
    background-color: rgba(0, 0, 0, 0.4);
    .modal-alert {
      position: absolute;
      padding: 18px 30px 30px;
      height: 320px;
      z-index: 11;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.4);
      width: 280px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: #fff;
      border-radius: 5px;
      z-index: 10;
      margin: auto;
      .modal-alert-header {
        display: flex;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #edf0f5;
        justify-content: space-between;
        .iconfont {
          cursor: pointer;
        }
      }
      .modal-alert-qrcode {
        padding: 20px 0 10px;
        font-size: 16px;
        text-align: center;
        #qr-code {
          height: 200px;
        }
        p {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
